export const searchEventLogItems = `
items {
  id
  sk
  type
  creatorId
  creator {
    id
    firstName
    lastName
    avatarHash
  }
  createdAt
  updatedAt
}
nextToken
total
__typename
`;

export const getEventLogItem = `
id
sk
type
eventLogOldImage
eventLogNewImage
`;
